export const prerender = 'auto';
export const ssr = true;
export const csr = true;
